import { getPersonAttributes } from 'src/feature-service/es-oneform-core-feature-service/pincode-data';
import { dealerAttributes } from './dealer';
import { orderAttributes } from './order';
import { vehicleAttributes } from './vehicle';

// person vehicle pedido dealer
export const testPincodePersonVehiclePedidoDealerDataPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-VEHICLE',
    token: 'VW_DDB_FRM_CEM_VENTA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(true)],
    },
    {
      attributes: [...vehicleAttributes],
    },
    {
      attributes: [...orderAttributes],
    },
    {
      attributes: [...dealerAttributes],
    },
  ],
};

export const testPincodePersonVehiclePedidoDealerDataNoPermite = {
  status: {
    result: 'success',
    timestamp: '2021-05-05 18:07:02',
    code: 1,
    time: 0.5742380619049072,
  },
  params: {
    pincode: 'PINCODE-PERSON-VEHICLE',
    token: 'VW_DDB_FRM_CEM_VENTA',
  },
  content: [
    {
      attributes: [...getPersonAttributes(false)],
    },
    {
      attributes: [...vehicleAttributes],
    },
    {
      attributes: [...orderAttributes],
    },
    {
      attributes: [...dealerAttributes],
    },
  ],
};
